import React, { type ReactNode } from "react";

interface FieldGroupProps {
  children: ReactNode;
  className?: string;
}

// Lays out a row of inputs and buttons with a small gap — horizontal on
// >=sm screens, vertical on mobile. First child takes remaining horizontal
// space on desktop; all children stretch to full width on mobile.
export function FieldGroup({ children, className }: FieldGroupProps) {
  return (
    <div
      className={[
        "flex flex-col gap-2 sm:flex-row",
        "[&>*]:w-full sm:[&>*]:w-auto",
        "sm:[&>input]:flex-1 sm:[&>div:first-child]:flex-1",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
}
